module.exports = __webpack_public_path__ + "img/1.3b8e4974.png";